"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var videoPlay_1 = require("./videoPlay");
var videoPause_1 = require("./videoPause");
var videoComplete_1 = require("./videoComplete");
var video25_1 = require("./video25");
var video50_1 = require("./video50");
var video75_1 = require("./video75");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.VideoEventNames.VideoPlay] = videoPlay_1.videoPlay,
    _a[analytics_layer_1.VideoEventNames.VideoPause] = videoPause_1.videoPause,
    _a[analytics_layer_1.VideoEventNames.VideoComplete] = videoComplete_1.videoComplete,
    _a[analytics_layer_1.VideoEventNames.Video25] = video25_1.video25,
    _a[analytics_layer_1.VideoEventNames.Video50] = video50_1.video50,
    _a[analytics_layer_1.VideoEventNames.Video75] = video75_1.video75,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
